import { createApp } from 'vue'
//import ElementPlus from 'element-plus'
import App from './App.vue'
//import './styles/index.scss'
//import './styles/tailwind.css'

import * as ElementPlusIconsVue from '@element-plus/icons-vue'

const app = createApp(App)

app.use(router)
//app.use(ElementPlus)
app.mount('#app')

// for (const [key, value] of Object.entries(ElementPlusIconsVue)) {
//   app.component(key, value)
// }
